import React from 'react';
import { useSourcing } from '../../contexts/SourcingContext';
import SourcingAgent from '../SourcingAgent';
const SupplierDiscovery: React.FC = () => {
  const {
    sourcingEvent
  } = useSourcing();
  if (!sourcingEvent) {
    return <div data-id="element-721">No active sourcing event. Please start a new one.</div>;
  }
  return <div className="flex flex-col h-[calc(100vh-120px)]" data-id="element-722">
      <div className="bg-white p-4 rounded-lg shadow-sm mb-4" data-id="element-723">
        <h1 className="text-xl font-semibold text-gray-800" data-id="element-724">
          {sourcingEvent.requirements.title}
        </h1>
        <p className="text-gray-600 mt-1" data-id="element-725">
          {sourcingEvent.requirements.description}
        </p>
      </div>
      {/* Main content - now just the SourcingAgent */}
      <div className="flex-1" data-id="element-726">
        <SourcingAgent data-id="element-727" />
      </div>
    </div>;
};
export default SupplierDiscovery;